import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Button } from '@mui/material';
import AxiosInstance from '../../../server/AxioInstance';
import TableComponent from '../../common/table/Table';
import ApproveBotton from '../../common/approveBotton/ApproveBotton';

const columns = [
  { id: 'name', label: 'Funcionario', align: 'left' },
  { id: 'sector', label: 'Setor', align: 'left' },
  { id: 'date', label: 'Data', align: 'center' },
  { id: 'acao', label: 'Ação', align: 'center' },
];

const LinkSectorUserConsult = ({ handleChangeComponent }) => {
  const [rows, setRows] = useState([]);

  const handleConsultLinkSectorUser = useCallback(async () => {
    const result = await AxiosInstance.get('/sector/consult-link-sector-user');
    const temp = result?.data?.rows?.map((item,) => ({
      ...item,
      ativo: item.active ? 'ATIVADO' : 'DESATIVADO',
      acao: (
        <ApproveBotton
          title="Editar Sub-Setor"
          url="/sector/activator-sectors-user"
          item={item}
          handleChangeComponent={handleChangeComponent}
          handleCosnult={handleConsultLinkSectorUser}
          edit={false}
        />
      ),
    }));
    setRows(temp);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleConsultLinkSectorUser();
  }, [handleConsultLinkSectorUser]);

  return (
    <Box m={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={4}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleChangeComponent('Criar vinculo', 'create')}
          >
            cadastrar
          </Button>
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
          <TableComponent columns={columns} rows={rows} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LinkSectorUserConsult;
